import { useCallback } from 'react';
import { PATHS } from '@ids/router/routes';
import useIDSPush from '@ids/hooks/useIDSPush';
import { useOverwhelmedOverlayDispatch } from '@ids/context/OverwhelmedOverlay';
import { useAppshellMeta, useFeatureToggle } from '@ids/appshell/hooks';
import { useCustomEvent } from '@ids/hooks';
import { useAppContext } from '@ids/context';
import { useAppshellRouter } from '@ids/appshell';
import { ensureEndingSlash, trimTrailingSlash } from '@ids/router/helpers';

export default function useQuestionnaireFlow() {
    const push = useIDSPush();
    const { isApp } = useAppshellMeta();
    const { host } = useAppshellRouter();
    const { location, idsPath } = useAppContext();
    const { p100IdsOverwhelmedOverlay } = useFeatureToggle();
    const { showOverwhelmedOverlay } = useOverwhelmedOverlayDispatch();
    const { openNativeOverlay } = useCustomEvent();
    const startQuestionnaire = useCallback(() => {
        if (p100IdsOverwhelmedOverlay) {
            return showOverwhelmedOverlay();
        }

        return isApp
            ? openNativeOverlay(`${host}${trimTrailingSlash(idsPath)}${PATHS.QUESTIONNAIRE}/${location.search}`)
            : push(ensureEndingSlash(PATHS.QUESTIONNAIRE));
    }, [
        p100IdsOverwhelmedOverlay,
        isApp,
        openNativeOverlay,
        host,
        idsPath,
        location.search,
        push,
        showOverwhelmedOverlay,
    ]);

    return { startQuestionnaire };
}
